import React from 'react';

const Dialog = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    title, 
    confirmText, 
    cancelText = 'Cancel', 
    isLoading = false,
    children 
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <div className="bg-custom-darker border border-custom-charcoal rounded-lg shadow-2xl max-w-md w-full p-6 animate-fade-in">
                {title && (
                    <h2 className="text-xl font-semibold text-white mb-4">{title}</h2>
                )}
                <div className="mb-6">
                    {children}
                </div>
                <div className="flex gap-3 justify-end">
                    <button
                        onClick={onClose}
                        disabled={isLoading}
                        className="px-4 py-2 rounded-md bg-custom-charcoal text-white hover:bg-custom-charcoal/80 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {cancelText}
                    </button>
                    {confirmText && (
                        <button
                            onClick={onConfirm}
                            disabled={isLoading}
                            className="px-4 py-2 rounded-md bg-red-500 text-white hover:bg-red-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {isLoading ? 'Processing...' : confirmText}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Dialog;
